import { render, staticRenderFns } from "./EnvironmentsList.vue?vue&type=template&id=a04a9924"
import script from "./EnvironmentsList.vue?vue&type=script&lang=js"
export * from "./EnvironmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports